import type {Endpoints} from "@hosttools/web/server/routes/routes.referral.types";
import {useContext, useMemo} from "react";

import {Base} from "../../../services/base";
import {HTTPContext} from "../../contexts";

export type ReferralData = Endpoints["/referral"][2];

export const useReferralService = () => {
    const http = useContext(HTTPContext);
    const base = useMemo(() => new Base<Endpoints>(http), [http]);
    return base;
};
